import { render } from "./PocTodo.vue?vue&type=template&id=9b812aea&scoped=true"
const script = {}

import "./PocTodo.vue?vue&type=style&index=0&id=9b812aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b812aea"]])

export default __exports__